import type { ReactNode } from "react";
import { Toast } from "./kit";
import type { ToastState } from "./useScript";

// Port of the ds KitStatusBar (ds/kit-shell.jsx): 9:41, dynamic island, signal bars, battery.
// `dark` = light content on a dark/brand header (Home); otherwise ink content.
function StatusBar({ dark }: { dark?: boolean }) {
  return (
    <div className={"hk-sb" + (dark ? " dark" : "")}>
      <span className="hk-sb-time">9:41</span>
      <span className="hk-sb-island" />
      <span className="hk-sb-r">
        <span className="hk-sb-sig">
          <i />
          <i />
          <i />
          <i />
        </span>
        <span className="hk-sb-bat">
          <i />
        </span>
      </span>
    </div>
  );
}

interface ScreenHostProps {
  dark?: boolean;
  /** A BottomSheet, rendered above the screen and below the toast. */
  sheet?: ReactNode;
  toast?: ToastState | null;
  children: ReactNode;
}

// Port of the handoff ScreenHost (frames/how/how-screens.html): one 390×844 phone screen with its
// sheet and toast slots, the status bar and the home indicator on top. Decorative only.
export function ScreenHost({ dark, sheet, toast, children }: ScreenHostProps) {
  return (
    <div className="hk-host">
      {children}
      {sheet}
      {toast && <Toast key={toast.k} message={toast.m} />}
      <StatusBar dark={dark} />
      <span className={"hk-hi" + (dark ? " dark" : "")} />
    </div>
  );
}
